import script from "./DepositosView.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositosView.vue?vue&type=script&setup=true&lang=js"

import "./DepositosView.vue?vue&type=style&index=0&id=0ad7c45e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ad7c45e"]])

export default __exports__